import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { Text } from '@wix/design-system';
import React from 'react';
import { parseDomain } from '@wix/domains-serverless-interface';
export const SUBDOMAIN_ROOT_TAKEN_DATA_HOOK = 'subdomain-root-taken';
export const SubdomainRootTaken = _ref => {
  let domainName = _ref.domainName;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    Trans = _DomainSearchSuiteMod.Trans;
  const parsedDomain = parseDomain(domainName ?? '');
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.DomainNameError, null, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    dataHook: SUBDOMAIN_ROOT_TAKEN_DATA_HOOK
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.storefront_results.error.subdomain",
    values: {
      domainName: parsedDomain.main
    },
    components: [/*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "bold"
    })]
  })));
};
//# sourceMappingURL=SubdomainRootTaken.js.map